module.exports = __webpack_public_path__ + "img/DefIMG_Prod_DK.bb551fa9.svg";